<template>
  <div
    v-if="currentAccount"
    class="row roomy"
  >
    <div class="margin-auto margin-bottom-4xl laptop:margin-right-0 laptop:margin-bottom-0">
      <commission-card
        :cost="300"
        :icon-count="1"
        :theme="theme"
        avatar="faSquare"
        description="Add that single icon you've always wanted in all of Font Awesome's styles."
        type="icon"
      >
        <footer
          slot="footer"
          class="section text-left"
        >
          <dl class="padding-0 margin-0 size-sm">
            <dt>Order ID:</dt>
            <dd>{{ currentOrder.number }}</dd>

            <dt class="sr-only">Email associated with subscription</dt>
            <dd>{{ currentAccount.email }}</dd>
          </dl>
        </footer>
      </commission-card>
    </div>

    <div class="column-12 laptop:column laptop:margin-left-4xl">
      <div class="margin-bottom-4xl">
        <h1 class="margin-top-0 laptop:margin-bottom-md">{{ selectedSalutation }}</h1>
        <p class="size-lg line-length-md">You've commissioned 1 icon to be added to Font Awesome.</p>
      </div>

      <ol style="--list-style-type: none; --padding-left: 0">
        <success-next-step
          title="Your Commission Adds a New Icon!"
          icon-name="faIcons"
        >
          <p>We'll add the icon you want across our 5 classic and 5 new sharp styles all of which will be released in Font Awesome.</p>
        </success-next-step>

        <success-next-step
          title="We'll Be In Touch About Next Steps"
          icon-name="faHandshake"
        >
          <p>
            We'll reach out to you via email shortly. We'll ask you some pointed questions about the icon you want to sponsor and take your original request as
            inspiration as we design. You'll be able to check it out before we ship that fresh icon in Font Awesome Pro. If you have any questions about the
            processing,
            <a href="mailto:icons@fontawesome.com?subject=I commissioned an icon and have a question">get in touch</a>
            .
          </p>
        </success-next-step>

        <success-next-step
          v-if="accessToPro"
          title="Font Awesome - Now Including Your Commission "
          icon-name="faRocketLaunch"
        >
          <p>
            Your commissioned icon will be part of Font Awesome's Pro icons. And your current Pro-level subscription will give you access to use these icons
            once they're ready and released as part of Font Awesome.
          </p>
        </success-next-step>

        <success-next-step
          v-else
          has-secondary-action
          title="Get a Pro Subscription to Use Your Commission in Font Awesome"
          icon-name="faRocketLaunch"
        >
          <p>
            Your commissioned icon will be part of Font Awesome's Pro icons.
            <strong>In order to use it when it's released, you'll need an active subscription.</strong>
            .
          </p>

          <site-link
            slot="action-primary"
            :to="{ name: `plans` }"
            class="button tablet:display-block laptop:display-inline-block"
          >
            Get a Pro Plan
          </site-link>

          <site-link
            slot="action-secondary"
            :to="{ name: `home` }"
            class="display-block text-center"
          >
            Check out all of Font Awesome
          </site-link>
        </success-next-step>
      </ol>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import sample from 'lodash/sample'
  import CommissionCard from '../components/CommissionCard'
  import SuccessNextStep from 'app/views/buy/components/SuccessNextStep'

  export default {
    name: 'Commission1Success',

    components: {
      CommissionCard,
      SuccessNextStep
    },

    props: {
      theme: {
        type: String,
        default: 'purple'
      }
    },

    computed: {
      ...mapGetters('orders', ['currentOrder']),

      ...mapGetters('accounts', ['currentAccount']),

      selectedSalutation() {
        const options = ['Great Success!', 'Somehow You Got Even More Awesome!', 'Font-Freaking-Tastic!']

        return sample(options)
      },

      accessToPro() {
        return this.$permits.has('accessToProVersions')
      }
    }
  }
</script>
